import React from "react";
import { KindTag } from "./KindTag";
import { RefChip } from "./RefChip";
import { listItems, valueText } from "./reviewAdapter";

const PROVENANCE = {
  référence: "repris de la référence",
  reference: "repris de la référence",
  "choix manuel": "votre choix",
  manual: "votre choix",
  "valeur saisie": "valeur saisie",
  typed: "valeur saisie",
  identique: "identique partout",
  identical: "identique partout",
};

function Empty() {
  return <span className="sv-empty">vide</span>;
}

/**
 * One value. `side` = "before" | "after"; `other` = the value on the other side, so a list shows
 * what leaves (struck, before) and what arrives (highlighted, after) element by element.
 */
export function ValueView({ value, other, side, changed }) {
  if (!value) return <Empty />;
  const old = side === "before" && changed;
  const neu = side === "after" && changed;
  const items = listItems(value);
  if (items) {
    const otherKeys = new Set((listItems(other) || []).map(i => i.key));
    const otherSingle = other && !listItems(other) ? other : null;
    if (!items.length) return <Empty />;
    return (
      <span className="sv-list">
        {items.map((it, i) => {
          const moved =
            changed &&
            !otherKeys.has(it.key) &&
            !(
              otherSingle &&
              otherSingle.ref &&
              it.ref &&
              otherSingle.ref.id === it.ref.id
            );
          return (
            <span
              key={`${it.key}-${i}`}
              className={`sv-list-item${
                moved
                  ? side === "before"
                    ? " sv-list-item--gone"
                    : " sv-list-item--added"
                  : ""
              }`}
            >
              {moved && side === "after" && <span className="sv-sign">+</span>}
              {moved && side === "before" && <span className="sv-sign">−</span>}
              {it.ref ? (
                <RefChip
                  refValue={it.ref}
                  struck={moved && side === "before"}
                  strong={moved && side === "after"}
                />
              ) : (
                <span
                  className={moved && side === "before" ? "sv-val--old" : ""}
                >
                  {it.text}
                </span>
              )}
            </span>
          );
        })}
      </span>
    );
  }
  if (value.ref)
    return <RefChip refValue={value.ref} struck={old} strong={neu} />;
  if (value.refs) return <Empty />;
  const text = valueText(value.raw);
  if (text === null) return <Empty />;
  return (
    <span className={old ? "sv-val--old" : neu ? "sv-val--new" : "sv-val"}>
      {text}
    </span>
  );
}

/**
 * One line of a card: label (with, on the after side, the kind tag under it) · value.
 * A changed line is tinted with its kind colour on the after side, greyed on the before side.
 */
export function ChangeLine({ line, side }) {
  const value = side === "before" ? line.before : line.after;
  const other = side === "before" ? line.after : line.before;
  const changed = line.changed;
  const prov = side === "after" && value && value.provenance;
  return (
    <div
      className={`sv-line sv-line--${side}${
        changed ? ` sv-line--changed sv-k-${line.kind}` : ""
      }`}
    >
      <div className="sv-line-label">
        <span className="sv-line-label-text">{line.label}</span>
        {side === "after" && changed && (
          <KindTag kind={line.kind} size="small" />
        )}
      </div>
      <div className="sv-line-value">
        <ValueView value={value} other={other} side={side} changed={changed} />
        {prov && <span className="sv-prov">{PROVENANCE[prov] || prov}</span>}
      </div>
    </div>
  );
}
